import { Store } from 'store';

const getOpRoute = (store: Store, routeType: number) => store.app.opRoutes.find((route) => route.type === routeType);

export default getOpRoute;
